<template>
  <div>
    <v-tooltip v-if="isActivo" left style="position: absolute;">
      <template v-slot:activator="{ on, attrs }">
        <v-btn fab fixed bottom right dark large color="primary" :style="{ marginLeft: '1vh', marginBottom: '160px' }"
          v-bind="attrs" v-on="on" @click="openDialog">
          <v-icon v-if="isBlocked" color="white">mdi-lock</v-icon>
          <v-icon v-else color="white">mdi-lock-open-variant</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('detailChangeStateUser.label.changeState.title') }}</span>
    </v-tooltip>

    <v-btn v-else class="btnDetails" icon x-large dark text style="margin-left:1vh;" @click="openDialog">
      <v-icon v-if="isBlocked" color="primary">mdi-lock</v-icon>
      <v-icon v-else color="primary">mdi-lock-open-variant</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" transition="dialog-bottom-transition" max-width="600" persistent>
      <template>
        <v-card class="container justify-content-between align-items-center">
          <button class="close-button" @click="closeDialog()">
            <span class="small-x">X</span>
          </button>
          <v-col cols="12" md="12" sm="6">
            <img src="https://ibliss-icons-prod.s3.us-east-1.amazonaws.com/marca_empresarial/image-welcomeDefault.png" class="custom-img" />
          </v-col>
          <h2 class="custom-title">{{ $t('detailChangeStateUser.label.changeState.text') }}</h2>

          <formChangeStateUser :dialog="dialog" :userSt="userStatus" :isActivo="isActivo" :isBlocked="isBlocked"
            :text="text" :userId="userId" :blockedByUser="blockedByUser" />
        </v-card>
      </template>

    </v-dialog>
  </div>


</template>
<script>
import formChangeStateUser from "./components/form_detail_change_state_user_component.vue";
import EventBus from "@/utils/event_bus.js";
export default {
  name: "ChangeStateUser",
  components: {
    formChangeStateUser,
  },
  props: {
    isBlocked: {
      type: Boolean,
      default: false,
    },
    userStatus: {
      type: Number,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    userId: {
      type: Number,
      default: null,
    },
    isActivo: {
      type: Boolean,
      default: true,
    },
    blockedByUser: {
      type: Number,
      default: null,
    }
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      EventBus.$emit("close-dialog");
      this.dialog = false;
      window.location.reload();
    },
  },
};
</script>

<style lang="css" scoped>

body {
    font-family: "Nunito Sans", sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
    font-family: "Amsi Pro", sans-serif;
}

.small-x {
  font-size: smaller;
}

.close-button {
    position: absolute;
    top: 5px;
    right: 10px;
    background: none;
    border: none;
    cursor: pointer;
}

.custom-img {
    width: 170px;
    height: auto;
    display: block;
    margin: 0 auto;
}

.custom-title {
    color: #6e17a5;
    justify-items: center;
}

.custom-text {
    font-size: 16px;
    color: #000000;
    text-align: center;
    margin: 5px;
}

.nombre {
    font-size: 14px;
    color: #414141;
}

.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 3vh;
    color: #6e17a5;
}

.v-btn {
    display: flex;
    align-items: center;
    justify-content: center;
}




@media screen and (max-width: 900px) {
    .row {
        padding-top: 0vh;
    }

    .custom-img {
        width: 100px;
    }

    .custom-title {
        color: #6e17a5;
        justify-items: center;
        font-size: 28px;
    }
}
</style>